export default "__VITE_ASSET__CwjMmO1h__"